<template>
  <div class="overview-profile" flat>
    <div class="flex-row-wrap-no-margin-top">
      <div>
        <label>Aktuell vereinslos</label>
        {{userData.no_team === true || userData.no_team === 'nein' ? 'Nein' : 'Ja'}}
      </div>
      <div>
        <label>Sprachen</label>
        <span v-for="(language,i) in userData.languages" :key="i">{{ language }}</span>
      </div>
    </div>
    <v-list>
      <v-list-group no-action>
        <template v-slot:activator>
          <h3>Mehr Infos</h3>
        </template>

        <div>
          <div class="history-content">
            <div class="flex-row-wrap">
              <div>
                <label>Geburtsort</label>
                {{userData.birthplace}}
              </div>
              <div>
                <label>Größte Erfolge</label>
                {{userData.successes}}
              </div>
              <div>
                <label>Bundesland</label>
                {{userData.living_in_state}}
              </div>
              <div>
                <label>Auszeichnungen</label>
                {{userData.prices}}
              </div>
            </div>
          </div>
        </div>
      </v-list-group>
    </v-list>
  </div>
</template>

<script>
export default {
  name: 'profile-trainer-bio',

  props: {
    userData: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
